import { render, staticRenderFns } from "./ControlPanelBlock.vue?vue&type=template&id=dafd577e&scoped=true&"
import script from "./ControlPanelBlock.vue?vue&type=script&lang=js&"
export * from "./ControlPanelBlock.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelBlock.vue?vue&type=style&index=0&id=dafd577e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd577e",
  null
  
)

export default component.exports